import { render, staticRenderFns } from "./forumdet.vue?vue&type=template&id=4a10717e&scoped=true"
import script from "./forumdet.vue?vue&type=script&lang=js"
export * from "./forumdet.vue?vue&type=script&lang=js"
import style0 from "./forumdet.vue?vue&type=style&index=0&id=4a10717e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10717e",
  null
  
)

export default component.exports